import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import { MCPConnectSessionRequest, MCPConnectSessionResponse } from "./types";

export * from "./types";

const ENDPOINTS = {
  MCP_CONNECT: "/api/v2/org/:organization_id/user/:user_id/mcp-connect",
};

/**
 * MCPAPI handles MCP OAuth connection flow.
 * For MCP server registration/management, use client.integrations.adminCreate/adminList/adminDelete
 */
export class MCPAPI {
  constructor(private client: CohesiveAPIClient) {}

  /**
   * Create an MCP OAuth connection session
   * @param data - Contains integration_id for the MCP server to connect to
   * @param config - Optional axios config
   * @returns Authorization URL to redirect user to
   */
  async createConnectSession(
    data: MCPConnectSessionRequest,
    config?: AxiosRequestConfig,
  ): Promise<string> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();
    const response = await this.client.axios.post<MCPConnectSessionResponse>(
      route(ENDPOINTS.MCP_CONNECT, {
        organization_id: organizationId,
        user_id: userId,
      }),
      data,
      config,
    );
    return response.data.data.authorization_url;
  }
}
